export const SUPPORT_EMAIL = "IdentityMatchingSolutions_Support_DL@ds.uhc.com";
export const IMPLEMENTATION_EMAIL = "EIMP_Support_Group@ds.uhc.com";
export const HUB_CONNECT = "https://hubconnect.uhg.com/groups/ims-patient";
export const ENHANCEMENT_REQUESTS =
  "https://ims.ideas.aha.io/portal_session/new";
export const APP_NAME = "Enterprise Individual Mastering Platform";
export const SEARCH_RECORDS_PER_PAGE = 6;
export const PATIENT_RECORDS_PER_PAGE = 4;
export const USER_AUTH_KEY = "USER_AUTH";
export const IMDM_ORG_NAME = "UHG";
export const quarantineClassificationsMap = {
  ProblematicOverlay: "Inconsistent Data",
  Insufficient: "Insufficient Data",
  Failure: "Failure",
  OverMerge: "OverMerge",
  TooManySourceRecords: "Too Many Source Records"
};
